import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { http, apiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";

function loadCheckout() {
  if (window.Razorpay) return Promise.resolve(true);
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export default function PayButton({ plan, highlight, enabled }) {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!enabled) {
    return <button disabled className="mt-6 h-12 rounded-xl bg-slate-200 text-slate-600 font-semibold cursor-not-allowed" data-testid={`plan-pay-button-${plan.id}`}>Online Payment - Coming Soon</button>;
  }

  const pay = async () => {
    if (!user) return nav("/login?next=/plans");
    setBusy(true);
    try {
      if (!(await loadCheckout())) throw new Error("Payment page लोड झाले नाही. Internet तपासा.");
      const { data } = await http.post("/payments/order", { plan_id: plan.id });
      const rz = new window.Razorpay({
        key: data.key_id,
        amount: data.amount,
        currency: data.currency,
        order_id: data.order_id,
        name: "99Bazaar Maharashtra",
        description: `${plan.name} Membership`,
        prefill: { name: data.name, contact: `+91${data.mobile}` },
        theme: { color: "#FF7A00" },
        handler: async (res) => {
          try {
            setUser((await http.post("/payments/verify", res)).data);
            toast.success("Payment यशस्वी! Membership सुरू झाली.");
            nav("/account");
          } catch (e) { toast.error(apiError(e)); }
        },
        modal: { ondismiss: () => setBusy(false) },
      });
      rz.on("payment.failed", () => toast.error("Payment अयशस्वी. कृपया पुन्हा प्रयत्न करा."));
      rz.open();
    } catch (e) {
      toast.error(apiError(e));
      setBusy(false);
    }
  };

  return (
    <button onClick={pay} disabled={busy} className={`mt-6 h-12 rounded-xl font-semibold text-white flex items-center justify-center gap-2 transition-colors disabled:opacity-70 ${highlight ? "bg-[var(--orange)] hover:bg-[#e86e00]" : "bg-[var(--navy)] hover:bg-[#123a85]"}`} data-testid={`plan-pay-button-${plan.id}`}>
      {busy && <Loader2 className="w-4 h-4 animate-spin" />} ₹{plan.price} Pay करा
    </button>
  );
}
